export const GET_COUNSELORS = 'GET_COUNSELORS'
export const ADD_COUNSELORS = 'ADD_COUNSELORS'
export const GET_COUNSELOR = 'GET_COUNSELOR'
export const RESET_COUNSELORS = 'RESET_COUNSELORS'
export const RESET_COUNSELOR = 'RESET_COUNSELOR'
export const PLAY_MOVIE = 'PLAY_MOVIE'

// userProfile
export const GET_PROFILE_DATA = 'GET_PROFILE_DATA'
export const UPDATE_PROFILE_DATA = 'UPDATE_PROFILE_DATA'
export const REMOVE_PROFILE_DATA = 'REMOVE_PROFILE_DATA'

// UI state
export const RESET_SCROLL_TOP = 'RESET_SCROLL_TOP'
export const UPDATE_SCROLL_TOP = 'UPDATE_SCROLL_TOP'
export const UPDATE_MENU_VISIBILITY = 'UPDATE_MENU_VISIBILITY'
export const UPDATE_SEARCH_VISIBILITY = 'UPDATE_SEARCH_VISIBILITY'
export const UPDATE_PRODUCT_DETAIL_VISIBILITY = 'UPDATE_PRODUCT_DETAIL_VISIBILITY'
export const ACCOUNT_MODAL_VISIBILITY = 'ACCOUNT_MODAL_VISIBILITY'
export const DRAWER_MENU_VISIBILITY = 'DRAWER_MENU_VISIBILITY'
export const FOOTER_MENU_VISIBILITY = 'FOOTER_MENU_VISIBILITY'
export const IS_LP = 'IS_LP'
export const GLOBAL_LOCK = 'GLOBAL_LOCK'
export const IS_PC = 'IS_PC'
export const OPEN_BASIC_MODAL = 'OPEN_BASIC_MODAL'
export const CLOSE_BASIC_MODAL = 'CLOSE_BASIC_MODAL'
export const SET_BASIC_MODAL_INFO = 'SET_BASIC_MODAL_INFO'

// Login Mutation
export const VERIFY_TOKEN = 'VERIFY_TOKEN'
export const GET_NONCE = 'GET_NONCE'

export const GET_SWITCH_STATUS = 'GET_SWITCH_STATUS'
export const GET_TOKEN_BY_NONCE = 'GET_TOKEN_BY_NONCE'
export const GET_TOKEN_BY_REISSUE_KEY = 'GET_TOKEN_BY_REISSUE_KEY'
export const LOGOUT = 'LOGOUT'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN'
export const POST_ACCESS_TOKEN = 'POST_ACCESS_TOKEN'
export const GET_LOGIN_MEMBER = 'GET_LOGIN_MEMBER'
export const RESET_LOGIN_ERROR = 'RESET_LOGIN_ERROR'
export const UPDATE_MEMBER_INFO = 'UPDATE_MEMBER_INFO'
export const RESET_LOGIN_MEMBER = 'RESET_LOGIN_MEMBER'
export const LOGIN_BY_FIREBASE_UID = 'LOGIN_BY_FIREBASE_UID'
export const REGISTRATION_BY_FIREBASE_UID = 'REGISTRATION_BY_FIREBASE_UID'
export const RESET_REGISTRATION_BY_FIREBASE_UID = 'RESET_REGISTRATION_BY_FIREBASE_UID'
export const RELATION_FIREBASE_UID = 'RELATION_FIREBASE_UID'
export const DELETE_FIREBASE_UID = 'DELETE_FIREBASE_UID'
// user
export const RESET_USER_DATA = 'GET_USER_DATA'

// TVmovie
export const GET_AUTH_TOKEN = 'GET_AUTH_TOKEN'
export const GET_TV_PROGRAM = 'GET_TV_PROGRAM'

// Trial
export const GET_TRIAL_RESULT = 'GET_TRIAL_RESULT'
export const RESET_TRIAL_RESULT = 'RESET_TRIAL_RESULT'

// Registration
export const RESET_NONCE = 'RESET_NONCE'
export const PROVISIONAL_REGISTRATION = 'PROVISIONAL_REGISTRATION'
export const MAIN_REGISTRATION = 'MAIN_REGISTRATION'

// Items
export const GET_ITEMS = 'GET_ITEMS'
export const RESET_ITEMS = 'RESET_ITEMS'
export const GET_ITEM = 'GET_ITEM'
export const SELECT_ITEM = 'SELECT_ITEM'
export const RESET_SELECTED_ITEM = 'RESET_SELECTED_ITEM'
export const GET_ITEM_RECOMENDS = 'GET_ITEM_RECOMENDS'
export const RESET_ITEM_RECOMENDS = 'RESET_ITEM_RECOMENDS'
export const GET_SUBSCRIPT_VIDEO = 'GET_SUBSCRIPT_VIDEO'
export const GET_TAG_ITEMS_ALL = 'GET_TAG_ITEMS_ALL'
export const SET_RETURN_TABLIST = 'SET_RETURN_TABLIST'
export const SET_TAG_ITEM_HISTORY = 'SET_TAG_ITEM_HISTORY'
export const RESET_TAG_ITEMS = 'RESET_TAG_ITEMS'
export const GET_NEXT_TAG_ITEMS = 'GET_NEXT_TAG_ITEMS'
export const GET_FILTERED_TAG_ITEMS = 'GET_FILTERED_TAG_ITEMS'
export const RESET_TAGITEMS_FILTER = 'RESET_TAGITEMS_FILTER'
export const SET_TAGITEM_FILTER = 'SET_TAGITEM_FILTER'
export const SET_ITEM_FAVORITE = 'SET_ITEM_FAVORITE'
export const SET_FAV_CHECKLIST = 'SET_FAV_CHECKLIST'
export const DELETE_FAV_CHECKLIST_ITEM = 'DELETE_FAV_CHECKLIST_ITEM'
export const RESET_FAV_CHECKLIST = 'RESET_FAV_CHECKLIST'
export const SET_FAV_STATUS = 'SET_FAV_STATUS'
export const GET_FAV_HISTORY = 'GET_FAV_HISTORY'
export const RESET_VIDEO_ITEMS = 'RESET_VIDEO_ITEMS'
export const SET_CHANGE_PARTNER_RESET = 'SET_CHANGE_PARTNER_RESET'
export const SET_VIDEO_PLAY_HISTORY = 'SET_VIDEO_PLAY_HISTORY'
export const GET_HISTORY_LIST = 'GET_HISTORY_LIST'
export const SET_ITEM_SEELATER = 'SET_ITEM_SEELATER'
export const SET_TAG_INFO = 'SET_TAG_INFO'
export const SET_CATPAGE_REFERRER = 'SET_CATPAGE_REFERRER'
export const SET_TEXT_DETAIL_OPEN = 'SET_TEXT_DETAIL_OPEN'
export const GET_CATEGORY_ITEMS = 'GET_CATEGORY_ITEMS'
export const GET_SEELATER_ITEMS = 'GET_SEELATER_ITEMS'

// Closed Menus
export const CHECK_HAVE_CLOSED_ITEMS = 'CHECK_HAVE_CLOSED_ITEMS'
export const GET_CLOSED_ITEMS_CACHE = 'GET_CLOSED_ITEMS_CACHE'
export const SET_CLOSED_ITEMS_CACHE = 'SET_CLOSED_ITEMS_CACHE'
export const SETSHOWN_CLOSED_ITEMS_CACHE = 'SETSHOWN_CLOSED_ITEMS_CACHE'
export const SET_CLOSED_ITEMS_LSKEY = 'SET_CLOSED_ITEMS_LSKEY'
export const SET_CLOSED_ITEMS_TOKEN = 'SET_CLOSED_ITEMS_TOKEN'

// payment api
export const GET_PAYMENT_INFO = 'GET_PAYMENT_INFO'
export const UPDATE_PAYMENT_INFO = 'UPDATE_PAYMENT_INFO'
export const RESET_PAYMENT_INFO = 'RESET_PAYMENT_INFO'
export const DELETE_PAYMENT_INFO = 'DELETE_PAYMENT_INFO'
export const GET_PAYMENT_HISTORY = 'GET_PAYMENT_HISTORY'

// unregister
export const UNREGISTER = 'UNREGISTER'

// entry
export const GET_ENTRY_DETAIL = 'GET_ENTRY_DETAIL'
export const GET_ENTRY_QUESTIONS = 'GET_ENTRY_QUESTIONS'

// user account
export const GET_ACCOUNT = 'GET_ACCOUNT'
export const RESET_ACCOUNT = 'RESET_ACCOUNT'
export const GET_USER_INFO = 'GET_USER_INFO'
export const GET_SUBSCRIPTION_INFO = 'GET_SUBSCRIPTION_INFO'
export const GET_USER_PAYMENT_HISTORY = 'GET_USER_PAYMENT_HISTORY'

//friend
export const TARGET_FRIEND = 'TARGET_FRIEND'
export const DELETE_FRIEND = 'DELETE_FRIEND'
export const GET_FRIEND_LIST = 'GET_FRIEND_LIST'

// user comment
export const GET_COMMENT_LIST = 'GET_COMMENT_LIST'
export const GET_TOP_STAR_LIST = 'GET_TOP_STAR_LIST'
export const SET_POINT_AVE = 'SET_POINT_AVE'

// subscription
export const UPDATE_PAYMENT_INFO_SUBSC = 'UPDATE_PAYMENT_INFO_SUBSC'
export const UPDATE_PAYMENT_INFO_SUBSC_REJOIN = 'UPDATE_PAYMENT_INFO_SUBSC_REJOIN'

// choun
export const UPDATE_PAYMENT_INFO_CHOUN = 'UPDATE_PAYMENT_INFO_CHOUN'
export const UPDATE_PAYMENT_INFO_CHOUN_REJOIN = 'UPDATE_PAYMENT_INFO_CHOUN_REJOIN'

// dialogs
export const NOTIFY_SEELATER_ADDED = 'NOTIFY_SEELATER_ADDED'

// academy
export const GET_PAYMENT_INFO_ACADEMY = 'GET_PAYMENT_INFO_ACADEMY'
export const UPDATE_PAYMENT_INFO_ACADEMY = 'UPDATE_PAYMENT_INFO_ACADEMY'

// recommend
export const SET_COLOR_SCHEME = 'SET_COLOR_SCHEME'
export const RESET_COLOR_SCHEME = 'RESET_COLOR_SCHEME'

// ulmar
export const GET_PAYMENT_INFO_ULMAR = 'GET_PAYMENT_INFO_ULMAR'
export const UPDATE_PAYMENT_INFO_ULMAR = 'UPDATE_PAYMENT_INFO_ULMAR'



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/store/mutation-types.js